export default __webpack_public_path__ + "static/media/yokara_icon.b54eec61.svg";